import './style.scss';

(function(am2) {
	am2.routes.blockDepartures = {
		lazy: {
			id: ['foundation'],
			callback() {
				jQuery(document).foundation();
			}
		}, 
	};
})(window.am2 || {});
